import React from 'react';
import { useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import ResponseResult from '../../shared/responses/ResponseResult';

import useGlobal from '../../store';
import CancelacionesUploadForm from './archivos/upload/components/CancelacionesUploadForm';

const mapState = (store) => {
  return {
    upload: store.modulo.cancelaciones.upload,
    archivos: store.modulo.cancelaciones.archivos,
  };
};

const mapActions = (actions) => {
  return {
    upload: actions.modulo.cancelaciones.upload,
    archivos: actions.modulo.cancelaciones.archivos,
  };
};

const CancelacionesUpload = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);
  const { data, busy, result } = state.upload;

  const isValid = !!data.file;

  useEffect(() => {
    return () => {
      actions.upload.reset();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleClose = () => {
    if (!busy) {
      props.history.replace('/modulos/cancelaciones/archivos');
    }
  };

  const upload = () => {
    actions.upload.upload((event) => {
      actions.upload.progress(Math.round((100 * event.loaded) / event.total));
    });
  };

  useEffect(() => {
    if (!!result && state.archivos.pagination.page === 1) {
      actions.archivos.paginate({});
    }
  }, [result]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!!result) {
    return (
      <div className="result-container">
        <ResponseResult
          title="Archivo enviado"
          result={result}
          onAction={handleClose}
        />
      </div>
    );
  }

  return (
    <>
      <Modal
        backdrop="static"
        keyboard={false}
        show={true}
        centered={true}
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>Subir archivo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CancelacionesUploadForm />
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            disabled={busy}
            onClick={handleClose}
          >
            Close
          </Button>
          <Button
            variant="primary"
            disabled={busy || !isValid}
            onClick={upload}
          >
            Subir
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CancelacionesUpload;
